export const sections = [
  { id: "inicio", label: "Início" },
  { id: "skills", label: "Entrega" },
  { id: "experiencia", label: "Trajetória" },
  { id: "projetos", label: "Projetos" },
  { id: "sobre", label: "Perfil" },
  { id: "contato", label: "Contato" },
] as const;

export type SectionId = (typeof sections)[number]["id"];

export const sectionIndex = (id: SectionId) =>
  String(sections.findIndex((s) => s.id === id) + 1).padStart(2, "0");
